import React, { useEffect, useState } from "react";
import MultiSelectCheckboxGroup from "../Partner/MultiSelectCheckboxGroup";
import {
  beautyOptions,
  functionalFoodBeveragesOptions,
  healthOptions,
  petNutritionOptions,
} from "../../constants/dataConstants";
import { Button, message } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  EditBrandInfo,
  SaveBrandDigitalInfo,
  SaveBrandInfo,
  updateBrandDigitalInfo,
} from "../../API/endpoints/Brands";
import MultiSelectCheckboxGroupWithAddItem from "../Partner/MultiSelectCheckboxGroupWithAddItem";

interface Props {
  setDefaultTab: (tab: string) => void;
  brandName: string;
  selectYearsOperations: string;
  currentRevenueStatus: string;
  socialLinks: any;
  marketplaces: any;
  setBrandId: (brandId: string) => void;
  focusCategories: any;
  selectOrg: string;
  setHealthChecked: any;
  setSelectedHealthOptions: any;
  setBeautyChecked: any;
  setSelectedBeautyOptions: any;
  setFoodChecked: any;
  setSelectedFoodOptions: any;
  setPetChecked: any;
  setSelectedPetOptions: any;
  selectedHealthOptions: any;
  healthChecked: any;
  healthOtherValue: any;
  selectedBeautyOptions: any;
  beautyChecked: any;
  beautyOtherValue: any;
  selectedFoodOptions: any;
  foodChecked: any;
  foodOtherValue: any;
  selectedPetOptions: any;
  petChecked: any;
  petOtherValue: any;
  setHealthOtherValue: any
  setBeautyOtherValue: any
  setFoodOtherValue: any
  setPetOtherValue: any
}

const FocusCategory = (props: Props) => {
  const {
    brandName,
    selectYearsOperations,
    currentRevenueStatus,
    socialLinks,
    marketplaces,
    setBrandId,
    focusCategories,
    selectOrg,
    setHealthChecked,
    setSelectedHealthOptions,
    setBeautyChecked,
    setSelectedBeautyOptions,
    setFoodChecked,
    setSelectedFoodOptions,
    setPetChecked,
    setSelectedPetOptions,
    selectedHealthOptions,
    healthChecked,
    healthOtherValue,
    selectedBeautyOptions,
    beautyChecked,
    beautyOtherValue,
    selectedFoodOptions,
    foodChecked,
    foodOtherValue,
    selectedPetOptions,
    petChecked,
    petOtherValue,
    setHealthOtherValue,
    setBeautyOtherValue,
    setFoodOtherValue,
    setPetOtherValue
  } = props;
  const params = useParams();
  const pathname = useLocation();
  const navigate = useNavigate();



  useEffect(() => {
    if (!focusCategories) return;

    props.focusCategories.forEach((item: any) => {
      const subCategories = item.sub_category || [];

      switch (item.category) {
        case "Health Supplements":
          setHealthChecked(true);
          setSelectedHealthOptions(subCategories);
          break;
        case "Beauty & Skin":
          setBeautyChecked(true);
          setSelectedBeautyOptions(subCategories);
          break;
        case "Functional Food & Beverages":
          setFoodChecked(true);
          setSelectedFoodOptions(subCategories);
          break;
        case "Pet Nutrition":
          setPetChecked(true);
          setSelectedPetOptions(subCategories);
          break;
      }
    });
  }, [focusCategories]);

  const handleSaveAndContinue = async () => {
    const categoriesSelected = [
      {
        checked: healthChecked,
        selected: selectedHealthOptions,
        label: "Health Supplements",
      },
      {
        checked: beautyChecked,
        selected: selectedBeautyOptions,
        label: "Beauty & Skin",
      },
      {
        checked: foodChecked,
        selected: selectedFoodOptions,
        label: "Functional Food & Beverages",
      },
      {
        checked: petChecked,
        selected: selectedPetOptions,
        label: "Pet Nutrition",
      },
    ];

    if (params?.brandId) {
      props.setDefaultTab("engagement-terms");
    } else {
      // Filter categories where the checkbox is checked
      const selectedCategories = categoriesSelected.filter(
        (cat) => cat.checked
      );

      if (selectedCategories.length === 0) {
        message.error("Please select at least one category before continuing.");
        return;
      }

      // Validate each checked category has at least one selected sub-category
      for (const cat of selectedCategories) {
        if (cat.selected.length === 0) {
          message.error(
            `Please select at least one sub-category in ${cat.label}.`
          );
          return;
        }
      }
      props.setDefaultTab("engagement-terms");
    }
  };

  return (
    <div className="p-6 bg-[#F9FAFB] min-h-screen">
      <div className="flex flex-col gap-[32px] max-w-[797px] ">
        <MultiSelectCheckboxGroupWithAddItem
          label="Health Supplements"
          options={healthOptions}
          selected={selectedHealthOptions}
          setSelected={setSelectedHealthOptions}
          checked={healthChecked}
          setChecked={setHealthChecked}
          otherInputValue={healthOtherValue}
          setOtherInputValue={setHealthOtherValue}
        />
        <MultiSelectCheckboxGroupWithAddItem
          label="Beauty & Skin"
          options={beautyOptions}
          selected={selectedBeautyOptions}
          setSelected={setSelectedBeautyOptions}
          checked={beautyChecked}
          setChecked={setBeautyChecked}
          otherInputValue={beautyOtherValue}
          setOtherInputValue={setBeautyOtherValue}
        />
        <MultiSelectCheckboxGroupWithAddItem
          label="Functional Food & Beverages"
          options={functionalFoodBeveragesOptions}
          selected={selectedFoodOptions}
          setSelected={setSelectedFoodOptions}
          checked={foodChecked}
          setChecked={setFoodChecked}
          otherInputValue={foodOtherValue}
          setOtherInputValue={setFoodOtherValue}
        />
        <MultiSelectCheckboxGroupWithAddItem
          label="Pet Nutrition"
          options={petNutritionOptions}
          selected={selectedPetOptions}
          setSelected={setSelectedPetOptions}
          checked={petChecked}
          setChecked={setPetChecked}
          otherInputValue={petOtherValue}
          setOtherInputValue={setPetOtherValue}
        />
      </div>

      <div className="flex justify-end pt-[50px]">
        <Button className="mr-2" onClick={() => navigate(-1)}>Cancel</Button>
        <Button
          onClick={handleSaveAndContinue}
          className="!bg-[#24a0ed]"
          type="primary"
        >
          Save & Continue
        </Button>
      </div>
    </div>
  );
};

export default FocusCategory;
